import { render, staticRenderFns } from "./AgbList.vue?vue&type=template&id=1245a030&scoped=true&"
import script from "./AgbList.vue?vue&type=script&lang=js&"
export * from "./AgbList.vue?vue&type=script&lang=js&"
import style0 from "./AgbList.vue?vue&type=style&index=0&id=1245a030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245a030",
  null
  
)

export default component.exports